const appendVat = (amount, vat = 24) => {
  const amountValue = Number(amount || 0);
  const vatValue = Number(vat || 0);
  const normalizedVat = vatValue >= 1 ? vatValue / 100 : vatValue;

  return Number((amountValue * (1 + normalizedVat)).toFixed(2));
};

export default appendVat;
